export default __webpack_public_path__ + "static/media/twitter.5d952925.svg";